import React, { Fragment, useState, useEffect } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Button, FormGroup, Label, Input, Alert, Form, FormInput, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import Navbarh from '../navbar/Navbar';
//import { API } from 'aws-amplify';
import '../estilos.css';
import { listLocacions } from '../../graphql/queries';
import {
    createLocacion, updateLocacion
} from '../../graphql/mutations';
import Pagination from "react-js-pagination";
import Moment from 'moment';
import * as IoIcons from 'react-icons/io';
import { generateClient } from "aws-amplify/api";

const API = generateClient();


function Locaciones() {
    //Declaración de variables        
    const [locaciones, setLocaciones] = useState([]);
    const [locacionesSinFiltro, setLocacionesSinFiltro] = useState([]);
    const [isDisabledl, setisDisabledl] = useState(false);
    const [mensajeAlert, setMensajeAlert] = useState("Hola");
    const [color, setColor] = useState("warning");
    const userName = window.$name;
    const ppalmacen = window.$Almacen ? window.$Almacen : false;
    const [aVisible, setAVisible] = useState(false);
    const [cargando, setCargando] = useState(false);
    const onDismiss = () => setAVisible(false);
    const [modal, setModal] = useState(false);
    const [locacionData, updateLocacionData] = useState({ locacion: '', espacio: 1, ocupado: false, activo: true })
    const [activeTab, setActiveTab] = useState('1');
    const [locacionEstado, setLocacionEstado] = useState("Mostrar");
    const [ultimoNumeroP, setultimoNumeroP] = useState(0);
    const [paginas, setPaginas] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [locacionesinicales, setLocacionesinicales] = useState
        ([/*{ locacion: 'A1(A)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A1(B)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A1(C)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A1(D)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A1(E)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A1(F)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A1(G)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A1(H)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A1(I)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A1(J)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A1(K)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A2(A)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A2(B)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A2(C)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A2(D)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A2(E)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A2(F)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A2(G)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A2(H)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A2(I)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A2(J)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A2(K)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A3(A)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A3(B)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A3(C)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A3(D)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A3(E)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A3(F)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A3(G)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A3(H)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A3(I)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A3(J)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A3(K)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A4(A)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A4(B)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A4(C)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A4(D)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A4(E)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A4(F)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A4(G)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A4(H)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A4(I)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A4(J)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A4(K)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A5(A)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A5(B)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A5(C)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A5(D)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A5(E)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A5(F)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A5(G)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A5(H)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A5(I)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A5(J)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A5(K)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A6(A)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A6(B)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A6(C)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A6(D)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A6(E)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A6(F)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A6(G)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A6(H)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A6(I)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A6(J)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A6(K)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A7(A)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A7(B)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A7(C)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A7(D)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A7(E)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A7(F)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A7(G)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A7(H)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A7(I)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A7(J)', espacio: 1, ocupado: false, activo: true },
        { locacion: 'A7(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B1(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B1(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B1(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B1(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B1(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B1(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B1(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B1(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B1(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B1(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B1(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B2(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B2(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B2(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B2(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B2(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B2(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B2(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B2(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B2(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B2(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B2(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B3(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B3(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B3(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B3(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B3(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B3(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B3(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B3(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B3(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B3(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B3(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B4(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B4(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B4(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B4(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B4(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B4(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B4(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B4(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B4(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B4(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B4(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B5(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B5(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B5(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B5(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B5(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B5(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B5(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B5(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B5(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B5(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B5(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B6(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B6(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B6(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B6(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B6(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B6(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B6(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B6(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B6(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B6(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B6(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B7(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B7(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B7(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B7(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B7(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B7(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B7(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B7(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B7(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B7(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'B7(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C1(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C1(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C1(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C1(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C1(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C1(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C1(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C1(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C1(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C1(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C1(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C2(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C2(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C2(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C2(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C2(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C2(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C2(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C2(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C2(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C2(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C2(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C3(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C3(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C3(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C3(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C3(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C3(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C3(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C3(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C3(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C3(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C3(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C4(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C4(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C4(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C4(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C4(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C4(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C4(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C4(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C4(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C4(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C4(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C5(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C5(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C5(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C5(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C5(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C5(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C5(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C5(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C5(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C5(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C5(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C6(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C6(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C6(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C6(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C6(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C6(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C6(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C6(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C6(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C6(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C6(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C7(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C7(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C7(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C7(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C7(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C7(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C7(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C7(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C7(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C7(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'C7(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D1(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D1(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D1(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D1(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D1(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D1(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D1(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D1(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D1(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D1(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D1(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D2(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D2(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D2(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D2(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D2(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D2(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D2(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D2(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D2(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D2(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D2(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D3(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D3(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D3(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D3(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D3(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D3(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D3(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D3(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D3(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D3(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D3(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D4(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D4(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D4(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D4(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D4(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D4(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D4(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D4(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D4(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D4(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D4(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D5(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D5(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D5(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D5(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D5(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D5(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D5(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D5(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D5(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D5(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D5(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D6(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D6(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D6(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D6(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D6(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D6(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D6(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D6(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D6(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D6(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D6(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D7(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D7(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D7(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D7(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D7(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D7(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D7(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D7(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D7(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D7(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'D7(K)', espacio: 1, ocupado: false, activo: true },*/
            { locacion: 'E1(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E1(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E1(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E1(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E1(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E1(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E1(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E1(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E1(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E1(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E1(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E2(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E2(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E2(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E2(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E2(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E2(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E2(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E2(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E2(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E2(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E2(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E3(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E3(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E3(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E3(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E3(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E3(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E3(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E3(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E3(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E3(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E3(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E4(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E4(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E4(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E4(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E4(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E4(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E4(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E4(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E4(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E4(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E4(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E5(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E5(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E5(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E5(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E5(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E5(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E5(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E5(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E5(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E5(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E5(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E6(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E6(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E6(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E6(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E6(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E6(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E6(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E6(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E6(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E6(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E6(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E7(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E7(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E7(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E7(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E7(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E7(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E7(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E7(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E7(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E7(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'E7(K)', espacio: 1, ocupado: false, activo: true },
            /*{ locacion: 'F1(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F1(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F1(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F1(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F1(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F1(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F1(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F1(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F1(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F1(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F1(K)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'F2(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F2(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F2(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F2(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F2(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F2(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F2(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F2(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F2(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F2(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F2(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F3(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F3(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F3(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F3(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F3(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F3(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F3(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F3(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F3(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F3(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F3(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F4(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F4(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F4(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F4(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F4(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F4(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F4(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F4(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F4(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F4(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F4(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F5(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F5(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F5(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F5(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F5(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F5(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F5(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F5(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F5(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F5(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F5(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F6(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F6(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F6(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F6(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F6(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F6(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F6(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F6(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F6(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F6(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F6(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F7(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F7(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F7(C)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'F7(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F7(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F7(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F7(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F7(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F7(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F7(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'F7(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G1(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G1(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G1(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G1(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G1(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G1(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G1(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G1(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G1(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G1(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G1(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G2(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G2(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G2(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G2(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G2(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G2(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G2(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G2(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G2(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G2(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G2(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G3(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G3(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G3(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G3(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G3(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G3(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G3(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G3(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G3(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G3(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G3(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G4(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G4(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G4(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G4(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G4(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G4(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G4(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G4(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G4(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G4(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G4(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G5(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G5(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G5(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G5(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G5(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G5(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G5(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G5(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G5(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G5(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G5(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G6(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G6(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G6(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G6(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G6(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G6(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G6(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G6(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G6(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G6(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G6(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'G7(A)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'G7(B)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'G7(C)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'G7(D)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'G7(E)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'G7(F)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'G7(G)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'G7(H)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'G7(I)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'G7(J)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'G7(K)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'H1(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H1(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H1(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H1(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H1(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H1(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H1(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H1(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H1(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H1(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H1(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H2(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H2(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H2(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H2(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H2(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H2(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H2(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H2(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H2(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H2(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H2(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H3(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H3(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H3(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H3(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H3(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H3(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H3(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H3(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H3(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H3(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H3(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H4(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H4(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H4(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H4(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H4(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H4(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H4(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H4(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H4(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H4(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H4(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H5(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H5(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H5(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H5(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H5(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H5(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H5(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H5(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H5(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H5(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H5(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H6(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H6(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H6(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H6(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H6(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H6(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H6(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H6(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H6(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H6(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H6(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'H7(A)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'H7(B)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'H7(C)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'H7(D)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'H7(E)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'H7(F)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'H7(G)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'H7(H)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'H7(I)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'H7(J)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'H7(K)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'I1(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I1(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I1(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I1(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I1(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I1(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I1(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I1(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I1(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I1(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I1(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I2(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I2(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I2(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I2(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I2(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I2(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I2(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I2(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I2(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I2(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I2(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I3(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I3(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I3(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I3(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I3(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I3(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I3(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I3(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I3(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I3(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I3(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I4(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I4(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I4(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I4(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I4(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I4(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I4(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I4(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I4(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I4(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I4(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I5(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I5(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I5(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I5(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I5(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I5(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I5(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I5(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I5(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I5(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I5(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I6(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I6(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I6(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I6(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I6(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I6(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I6(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I6(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I6(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I6(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I6(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'I7(A)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'I7(B)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'I7(C)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'I7(D)', espacio: 1, ocupado: false, activo: true },       
            { locacion: 'I7(E)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'I7(F)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'I7(G)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'I7(H)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'I7(I)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'I7(J)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'I7(K)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'J1(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J1(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J1(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J1(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J1(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J1(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J1(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J1(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J1(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J1(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J1(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J2(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J2(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J2(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J2(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J2(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J2(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J2(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J2(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J2(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J2(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J2(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J3(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J3(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J3(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J3(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J3(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J3(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J3(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J3(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J3(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J3(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J3(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J4(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J4(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J4(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J4(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J4(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J4(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J4(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J4(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J4(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J4(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J4(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J5(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J5(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J5(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J5(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J5(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J5(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J5(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J5(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J5(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J5(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J5(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J6(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J6(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J6(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J6(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J6(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J6(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J6(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J6(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J6(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J6(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J6(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'J7(A)', espacio: 1, ocupado: false, activo: true },   
            { locacion: 'J7(B)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'J7(C)', espacio: 1, ocupado: false, activo: true },     
            { locacion: 'J7(D)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'J7(E)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'J7(F)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'J7(G)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'J7(H)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'J7(I)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'J7(J)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'J7(K)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'K1(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K1(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K1(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K1(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K1(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K1(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K1(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K1(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K1(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K1(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K1(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K2(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K2(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K2(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K2(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K2(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K2(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K2(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K2(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K2(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K2(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K2(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K3(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K3(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K3(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K3(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K3(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K3(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K3(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K3(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K3(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K3(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K3(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K4(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K4(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K4(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K4(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K4(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K4(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K4(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K4(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K4(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K4(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K4(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K5(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K5(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K5(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K5(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K5(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K5(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K5(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K5(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K5(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K5(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K5(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K6(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K6(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K6(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K6(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K6(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K6(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K6(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K6(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K6(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K6(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K6(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'K7(A)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'K7(B)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'K7(C)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'K7(D)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'K7(E)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'K7(F)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'K7(G)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'K7(H)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'K7(I)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'K7(J)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'K7(K)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'L1(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L1(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L1(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L1(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L1(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L1(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L1(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L1(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L1(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L1(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L1(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L2(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L2(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L2(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L2(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L2(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L2(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L2(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L2(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L2(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L2(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L2(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L3(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L3(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L3(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L3(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L3(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L3(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L3(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L3(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L3(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L3(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L3(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L4(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L4(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L4(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L4(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L4(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L4(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L4(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L4(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L4(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L4(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L4(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L5(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L5(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L5(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L5(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L5(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L5(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L5(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L5(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L5(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L5(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L5(K)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'L6(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L6(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L6(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L6(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L6(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L6(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L6(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L6(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L6(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L6(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L6(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L7(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L7(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L7(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L7(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L7(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L7(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L7(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L7(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L7(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L7(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'L7(K)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'M1', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M2', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M3', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M4', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M5', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M6', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M7', espacio: 1, ocupado: false, activo: true },   
            { locacion: 'M1(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M1(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M1(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M1(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M1(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M1(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M1(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M1(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M1(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M1(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M1(K)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'M2(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M2(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M2(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M2(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M2(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M2(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M2(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M2(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M2(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M2(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M2(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M3(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M3(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M3(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M3(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M3(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M3(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M3(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M3(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M3(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M3(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M3(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M4(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M4(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M4(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M4(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M4(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M4(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M4(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M4(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M4(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M4(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M4(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M5(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M5(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M5(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M5(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M5(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M5(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M5(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M5(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M5(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M5(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M5(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M6(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M6(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M6(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M6(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M6(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M6(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M6(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M6(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M6(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M6(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M6(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'M7(A)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'M7(B)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'M7(C)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'M7(D)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'M7(E)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'M7(F)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'M7(G)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'M7(H)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'M7(I)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'M7(J)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'M7(K)', espacio: 1, ocupado: false, activo: true }, 
            { locacion: 'N1', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N2', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N3', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N4', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N5', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N6', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N7', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N1(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N1(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N1(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N1(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N1(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N1(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N1(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N1(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N1(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N1(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N1(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N2(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N2(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N2(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N2(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N2(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N2(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N2(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N2(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N2(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N2(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N2(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N3(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N3(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N3(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N3(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N3(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N3(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N3(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N3(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N3(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N3(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N3(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N4(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N4(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N4(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N4(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N4(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N4(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N4(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N4(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N4(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N4(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N4(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N5(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N5(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N5(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N5(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N5(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N5(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N5(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N5(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N5(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N5(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N5(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N6(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N6(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N6(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N6(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N6(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N6(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N6(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N6(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N6(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N6(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N6(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N7(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N7(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N7(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N7(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N7(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N7(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N7(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N7(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N7(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N7(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'N7(K)', espacio: 1, ocupado: false, activo: true },    
            { locacion: 'O1', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O2', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O3', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O4', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O5', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O6', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O7', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O1(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O1(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O1(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O1(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O1(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O1(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O1(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O1(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O1(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O1(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O1(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O2(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O2(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O2(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O2(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O2(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O2(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O2(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O2(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O2(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O2(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O2(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O3(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O3(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O3(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O3(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O3(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O3(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O3(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O3(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O3(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O3(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O3(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O4(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O4(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O4(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O4(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O4(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O4(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O4(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O4(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O4(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O4(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O4(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O5(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O5(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O5(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O5(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O5(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O5(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O5(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O5(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O5(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O5(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O5(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O6(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O6(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O6(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O6(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O6(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O6(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O6(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O6(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O6(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O6(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O6(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O7(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O7(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O7(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O7(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O7(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O7(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O7(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O7(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O7(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O7(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'O7(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P1', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P2', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P3', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P4', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P5', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P6', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P7', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P1(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P1(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P1(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P1(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P1(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P1(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P1(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P1(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P1(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P1(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P1(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P2(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P2(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P2(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P2(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P2(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P2(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P2(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P2(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P2(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P2(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P2(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P3(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P3(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P3(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P3(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P3(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P3(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P3(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P3(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P3(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P3(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P3(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P4(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P4(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P4(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P4(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P4(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P4(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P4(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P4(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P4(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P4(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P4(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P5(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P5(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P5(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P5(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P5(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P5(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P5(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P5(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P5(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P5(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P5(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P6(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P6(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P6(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P6(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P6(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P6(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P6(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P6(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P6(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P6(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P6(K)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P7(A)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P7(B)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P7(C)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P7(D)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P7(E)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P7(F)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P7(G)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P7(H)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P7(I)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P7(J)', espacio: 1, ocupado: false, activo: true },
            { locacion: 'P7(K)', espacio: 1, ocupado: false, activo: true },*/

        ])

    Moment.locale('en');
    var now = new Date();

    const toggle1 = tab => {
        if (activeTab !== tab) setActiveTab(tab);
        if (tab > 1) setAVisible(false);
    }

    const toggle = () => setModal(!modal);

    // current page
    const [currentPageLocation, setCurrentPageLocation] = useState(1);
    // total records per page to display   
    const [recordPerPage, setRecordPerPage] = useState(12);

    // range of pages in paginator
    const pageRange = 5;
    function handlePageChangeLocacion(pageNumber) {
        setAVisible(false);
        setCargando(false);

        setCurrentPageLocation(pageNumber);

        setLocaciones(locacionesSinFiltro.filter(locacion => locacion.indexpag === pageNumber));
        //busquedaPlaneacion(planeacionSinFiltro, pageNumber, fechaPBusqueda); 
    }

    //Método useEffect
    useEffect(() => {
        fetchLocacion();
    }, []);


    //Obtiene los datos guardados de Locación
    async function fetchLocacion() {
        setCargando(true);
        var pag = 1;
        var i = 1;
        var index = 1
        var paginasp = [];
        let filter = {
            activo: {
                eq: true
            }
        }

        //const apiData = await API.graphql({ query: listLocacions, variables: { filter: filter, limit: 100000000 } });
        var nextToken = null;
        var apiData = [];
        do {
            const apiOData = await API.graphql({ query: listLocacions, variables: { filter: filter, limit: 100000000, nextToken } });
            const odatos = await apiOData.data.listLocacions.items;
            nextToken = await apiOData.data.listLocacions.nextToken;
            apiData = await [...apiData, ...odatos];
        } while (nextToken != null);

        const locacionesFromAPI = apiData.sort((a, b) =>
            a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0);
        await Promise.all(locacionesFromAPI.map(async locacion => {
            locacion.indexpag = pag;
            index++;
            if (index > recordPerPage) {
                paginasp.push({ pagina: pag, paginareal: pag });
                index = 1;
                pag++;
            }
            locacion.color = "";
            if (i === 2) {
                locacion.color = "table-active";
                i = 0;
            }
            i++;

            return locacion;
        }))

        if (locacionesFromAPI.length) {
            setTotalRecords(locacionesFromAPI.length);
            const lengthlocaciones = locacionesFromAPI.length;
            const prepaginas = parseInt(lengthlocaciones / recordPerPage);
            const paginas = prepaginas * recordPerPage < lengthlocaciones ? prepaginas + 1 : prepaginas;
            if (paginas > paginasp.length)
                paginasp.push({ pagina: paginas })
            setPaginas(paginasp);
            setultimoNumeroP(paginasp[paginasp.length - 1].pagina);
        } else {
            setPaginas([]);
            setultimoNumeroP(0);
            setTotalRecords(0);
        }
        setLocacionesSinFiltro(locacionesFromAPI);
        setLocaciones(locacionesFromAPI.filter(locacion => locacion.indexpag === currentPageLocation));
        setCargando(false);
    }
    //Obtiene los datos guardados de Locación y revisa si la locación guardada ya existe
    async function fetchLocacionRepetida(locacionr) {
        var repetida = false;
        let filter = {
            activo: {
                eq: true
            }
        }

        //const apiData = await API.graphql({ query: listLocacions, variables: { filter: filter, limit: 100000000 } });
        var nextToken = null;
        var apiData = [];
        do {
            const apiOData = await API.graphql({ query: listLocacions, variables: { filter: filter, limit: 100000000, nextToken } });
            const odatos = await apiOData.data.listLocacions.items;
            nextToken = await apiOData.data.listLocacions.nextToken;
            apiData = await [...apiData, ...odatos];
        } while (nextToken != null);

        const locacionesFromAPI = apiData.filter(locacion => locacion.locacion.toLowerCase() === locacionr.toLowerCase());
        if (locacionesFromAPI.length > 0)
            repetida = true;

        return repetida
    }

    function clicAgregarLocacion() {
        updateLocacionData(() => ({ ...locacionData, ['locacion']: '', ['espacio']: 1, ['ocupado']: false, ['activo']: true, ['Reg_Ins_Usuario']: '' }));
        setLocacionEstado("Nueva");
        setAVisible(false);
    }
    //Revisa cambios en los inputs
    function onChanges(e) {
        e.persist()
        updateLocacionData(() => ({ ...locacionData, [e.target.name]: e.target.value }));
    }
    async function guardarLocaciones() {
        setAVisible(false);
        setisDisabledl(true);
        setCargando(true);
        try {

            /*var locacionesi=locacionesinicales.sort((a, b) =>
            a.orden < b.orden ? 1 : a.orden > b.orden ? -1 : 0);*/
            const orden = 343;
            await Promise.all(locacionesinicales.map(async (locaciones, i) => {
                locaciones.Reg_Ins_Usuario = userName;
                locaciones.orden = orden + i + 1;
                await API.graphql({ query: createLocacion, variables: { input: locaciones } });
                setMensajeAlert("Operación exitosa");
                setColor("primary");
                await fetchLocacion();
                setAVisible(true);
                setCargando(false);

            }));

            setMensajeAlert("Operación exitosa");
            setColor("primary");
            setAVisible(true);
            setCargando(false);
            setLocacionEstado("Mostrar");
            setisDisabledl(false);
            fetchLocacion();


        } catch (e) {
            window.scrollTo(0, 0);
            setMensajeAlert("No fue posible realizar la operación: revise su conexión a internet y vuelva a intentar");
            setColor("warning");
            setAVisible(true);
            setCargando(false);
            setisDisabledl(false);
        }
    }
    async function guardarLocacion() {
        setAVisible(false);
        setisDisabledl(true);
        setCargando(true);
        try {
            if (locacionData.locacion === "") {
                setMensajeAlert("Faltan datos: los campos marcados con un asterisco son obligatorios");
                setColor("warning");
                setAVisible(true);
                window.scrollTo(0, 0);
                setisDisabledl(false);
            } else {
                const repetida = await fetchLocacionRepetida(locacionData.locacion);
                if (repetida === true) {
                    setMensajeAlert("Locación repetida; ingrese una locación diferente y vuelva a intentarlo " + repetida + " L:" + locacionData.locacion);
                    setColor("warning");
                    setAVisible(true);
                    window.scrollTo(0, 0);
                    setisDisabledl(false);
                } else {
                    locacionData.Reg_Ins_Usuario = userName;
                    await API.graphql({ query: createLocacion, variables: { input: locacionData } });
                    setMensajeAlert("Operación exitosa");
                    setColor("primary");
                    setCargando(false);
                    setAVisible(true);
                    setLocacionEstado("Mostrar");
                    setisDisabledl(false);
                    fetchLocacion();

                }
            }

        } catch (e) {
            window.scrollTo(0, 0);
            setMensajeAlert("No fue posible realizar la operación: revise su conexión a internet y vuelva a intentar");
            setColor("warning");
            setCargando(false);
            setAVisible(true);
            setisDisabledl(false);
        }
    }
    async function ocuparLocacion(locacion) {
        try {
            delete locacion.createdAt;
            delete locacion.updatedAt;
            delete locacion.__typename;
            delete locacion.indexpag;
            delete locacion.color;
            locacion.Reg_Mod_Usuario = userName;
            locacion.ocupado = true;
            locacion.fechaDeOcupacion = now;
            locacion.espacioOcupado = locacion.espacio;
            await API.graphql({ query: updateLocacion, variables: { input: locacion } });
            window.scrollTo(0, 0);
            setMensajeAlert("Operación exitosa");
            setColor("info");
            setAVisible(true);
            fetchLocacion();

        } catch (e) {
            window.scrollTo(0, 0);
            setMensajeAlert("Hay problemas registrando las locaciones");
            setColor("warning");
            setAVisible(true);
        }
    }
    async function liberarlocacionb(locacion) {
        try {
            delete locacion.createdAt;
            delete locacion.updatedAt;
            delete locacion.__typename;
            delete locacion.indexpag;
            delete locacion.color;
            locacion.recibaSerialID = "";
            locacion.Reg_Mod_Usuario = userName;
            locacion.ocupado = false;
            locacion.fechaDeliberacion = now;
            locacion.espacioOcupado = 0;
            await API.graphql({ query: updateLocacion, variables: { input: locacion } });
            window.scrollTo(0, 0);
            setMensajeAlert("Operación exitosa");
            setColor("info");
            setAVisible(true);
            fetchLocacion();
        } catch (e) {
            window.scrollTo(0, 0);
            setMensajeAlert("Hay problemas liberando las locaciones");
            setColor("warning");
            setAVisible(true);
        }
    }
    function manageLocacion(liberar, locacion) {
        if (liberar === true)
            liberarlocacionb(locacion);
        else
            ocuparLocacion(locacion);

    }
    return (
        <>
            {ppalmacen == true && (
                <Fragment>
                    <div className="conteiner3">
                        <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
                            {mensajeAlert}
                        </Alert>
                        {cargando === true && (
                            <Row>
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                                    <img width="150px" src="assets/img/preloader.gif" />
                                </div>
                            </Row>
                        )}
                        {locacionEstado === 'Mostrar' && (
                            <Row>
                                {/*<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 margintop20px" >                                         
                                            <button className="cbutton btn-success floatleft  ml-2 "  title="Agregar locación"  onClick={() => { clicAgregarLocacion();}}> Agregar locación</button>                                                                                                                                                                                                         
                                        </div>*/ }
                                {/*<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 margintop20px" >
                                    <button className="cbutton btn-success floatleft  ml-2 " title="Agregar locaciones inicales" onClick={() => { guardarLocaciones(); }}> Agregar locaciones inicales</button>
                                </div>*/}
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left  margintop20px" >
                                    <button className="cbutton btn-dark floatright  " title="Recargar página" onClick={() => { fetchLocacion(); }}><IoIcons.IoMdRefresh /> Recargar </button>
                                </div>
                                <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                    <Table className="margintop20px mb-2 scroll ">
                                        <Thead class="thead-secondary">
                                            <Tr>
                                                <Th className="minwidth80px"  >Locación</Th>
                                                <Th>Espacio</Th>
                                                <Th>Espacio ocupado</Th>
                                                <Th>Ocupado</Th>
                                                <Th className="width80px">Acciones </Th>
                                            </Tr>
                                        </Thead>
                                        <Tbody>
                                            {locaciones.map(locacion => (
                                                <Tr class={locacion.color}>
                                                    <Td className="margintopmobil20px">{locacion.locacion}</Td>
                                                    <Td className="margintopmobil20px">{locacion.espacio}</Td>
                                                    <Td className="margintopmobil20px">{locacion.espacioOcupado}</Td>
                                                    <Td className="margintopmobil20px">{locacion.ocupado === true ? "Sí" : "No"}</Td>
                                                    <Td className="margintopmobil20px marginbottommobil40px">{locacion.ocupado === true ?
                                                        <button className="cbutton btn-info floatleft  ml-2 " title="Desocupar" onClick={() => { manageLocacion(true, locacion); }}> Desocupar </button> :
                                                        <button className="cbutton btn-info floatleft  ml-2 " title="Ocupar" onClick={() => { manageLocacion(false, locacion); }}> Ocupar </button>
                                                    }
                                                    </Td>
                                                </Tr>
                                            ))}
                                        </Tbody>
                                    </Table>
                                </div>
                                <div className=" col-lg-12 col-md-12 col-sm-12 mt-3 mb-3">
                                    Página {currentPageLocation}, mostrando del{" "}
                                    {recordPerPage * currentPageLocation - recordPerPage + 1} al{" "}
                                    {totalRecords < recordPerPage * currentPageLocation
                                        ? totalRecords
                                        : recordPerPage * currentPageLocation}{" "}
                                    de {totalRecords} registros
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12  ">
                                    <div className="floatcenter">
                                        <Pagination
                                            itemClass="page-item" // add it for bootstrap 4
                                            linkClass="page-link" // add it for bootstrap 4
                                            activePage={currentPageLocation}
                                            itemsCountPerPage={recordPerPage}
                                            totalItemsCount={totalRecords}
                                            pageRangeDisplayed={pageRange}
                                            onChange={handlePageChangeLocacion}
                                        />
                                    </div>
                                </div>

                            </Row>

                        )}
                        {locacionEstado === 'Nueva' && (
                            <>
                                <Row className="margintop20px">
                                    <h5>Agregar locación</h5>
                                </Row>
                                <Row className="margintop20px">
                                    <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                                        <Label className="floatleft" >Locación*: </Label>
                                        <Input name="locacion" placeholder="Locación " onChange={onChanges} autoFocus />
                                    </div>
                                    <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                        <FormGroup >
                                            <Label className="floatleft ">Espacios*:</Label>
                                            <select name="espacio" className="activofloat custom-select" onChange={onChanges}>
                                                <option value="1" >1</option>
                                            </select>
                                        </FormGroup>
                                    </div>
                                    <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                        <FormGroup>
                                            <Label for="activo" className="floatleft" >Activo* </Label>
                                            <select name="activo" id="activo" className="activofloat custom-select" onChange={onChanges}>
                                                <option value="true">Sí</option>
                                                <option value="false">No</option>
                                            </select>
                                        </FormGroup>
                                    </div>
                                </Row>
                                <div className="margintop20px">
                                    <Button className="floatright " onClick={() => { setLocacionEstado("Mostrar"); }} color="danger" >
                                        Cancelar
                                    </Button>
                                    <Button className="floatright " onClick={guardarLocacion} isDisabled={isDisabledl} color="primary" >
                                        Guardar
                                    </Button>
                                </div>
                                {/*<div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 " style={{ marginTop: 20 }}>{JSON.stringify(locacionData)}</div>*/}
                            </>
                        )}
                    </div>

                </Fragment>
            )}
        </>
    )
};



export default Locaciones
